
import { mapMutations } from 'vuex';
import * as types from '~/types';
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * @description 成功展示文案
     */
    showText() {
      if (this.type === 'forget') {
        return this.$t('login.success-text.forget');
      } else if (this.type === 'bind') {
        return this.$t('login.success-text.bind');
      }
      return '修改成功';
    },
  },
  methods: {
    ...mapMutations('user', {
      hide: types.HIDE_LOGIN_FORM,
    }),
  },
};
